

import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_SURVEY_LIST_REQUEST = "FETCH_SURVEY_LIST_REQUEST";
export const FETCH_SURVEY_LIST_SUCCESS = "FETCH_SURVEY_LIST_SUCCESS";
export const FETCH_SURVEY_LIST_FAILURE = "FETCH_SURVEY_LIST_FAILURE";

export const FETCH_SURVEY_DETAIL_REQUEST = "FETCH_SURVEY_DETAIL_REQUEST";
export const FETCH_SURVEY_DETAIL_SUCCESS = "FETCH_SURVEY_DETAIL_SUCCESS";
export const FETCH_SURVEY_DETAIL_FAILURE = "FETCH_SURVEY_DETAIL_FAILURE";

export const FETCH_USER_SURVEY_LIST_REQUEST = "FETCH_USER_SURVEY_LIST_REQUEST";
export const FETCH_USER_SURVEY_LIST_SUCCESS = "FETCH_USER_SURVEY_LIST_SUCCESS";
export const FETCH_USER_SURVEY_LIST_FAILURE = "FETCH_USER_SURVEY_LIST_FAILURE";

/* ================================
   FETCH SURVEY LIST
================================ */
export const fetchSurveyList = (params) => async (dispatch) => {
  dispatch({ type: FETCH_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/user-survey-list/single`,
      {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch survey list");
    throw error;
  }
};

/* ================================
   FETCH SURVEY DETAIL
================================ */
export const fetchSurveyDetail = (surveyId) => async (dispatch) => {
  dispatch({ type: FETCH_SURVEY_DETAIL_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/user-survey/${surveyId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_SURVEY_DETAIL_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_SURVEY_DETAIL_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

/* ================================
   FETCH USER SURVEY LIST (PER CANTEEN)
================================ */
export const fetchUserSurveyList = (canteen_id) => async (dispatch) => {
  dispatch({ type: FETCH_USER_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/usersurveyList`,
      {
        params: { canteen_id }, // ✅ FIXED
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_USER_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data; // ✅ IMPORTANT
  } catch (error) {
    dispatch({
      type: FETCH_USER_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch user survey list");
    throw error;
  }
};
